import { SHOW_ERROR, CLEAR_ERROR } from './unpaidErrorActions';



const initErrType = localStorage.getItem('unpaidError');

const initialState = {
  unpaidError: initErrType || null,
};

export default function unpaidErrorReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_ERROR: {
      const unpaidError = action.payload?.unpaidError ?? null;

      try {
        if (unpaidError) {
          localStorage.setItem('unpaidError', unpaidError);
        } else {
          localStorage.removeItem('unpaidError');
        }
      } catch (e) {
        // ignore storage errors
      }

      return {
        ...state,
        unpaidError,
      };
    }
    case CLEAR_ERROR: {
      try {
        localStorage.removeItem('unpaidError');
      } catch (e) {
        // ignore storage errors
      }
      return {
        unpaidError: null,
      };
    }
    default:
      return state;
  }
}